import { getValues } from "../../../../helpers/Utils";

export const getValuesForSubmit = <T extends object>(values: T, dependenceLength?: number) =>
	getValues<T>(values).map((value: T[keyof T] & { isEdit: boolean; groups?: Array<any> }) => {
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const { isEdit, groups, ..._otherValue } = value;

		if (dependenceLength && !!groups?.length) {
			const _groups = [...groups];
			_groups.length = dependenceLength;

			return {
				..._otherValue,
				groups: _groups,
			};
		}

		return _otherValue;
	});
